/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Born_Born_Gadfly_TalkInputs */

const fr_born_born_gadfly_talk = /** @type {(inputs: Born_Born_Gadfly_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible en showcase`)
};

/**

* @param {Born_Born_Gadfly_TalkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const born_born_gadfly_talk = /** @type {((inputs?: Born_Born_Gadfly_TalkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Born_Born_Gadfly_TalkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_born_born_gadfly_talk(inputs)
});